import { render, staticRenderFns } from "./OrderedMaterials.vue?vue&type=template&id=7e229455&scoped=true"
import script from "./OrderedMaterials.vue?vue&type=script&lang=js"
export * from "./OrderedMaterials.vue?vue&type=script&lang=js"
import style0 from "./OrderedMaterials.vue?vue&type=style&index=0&id=7e229455&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e229455",
  null
  
)

export default component.exports